import React, { useEffect, useMemo } from "react";
import { useState } from "react";
import {
	Accordion,
	Button,
	Form,
	InputGroup,
	Modal,
	Row,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import TimePicker from "react-bootstrap-time-picker";
import LinkedCameraIcon from '@mui/icons-material/LinkedCamera';
import {
	setData,
	setForm,
	setSubChild,
} from "../../../redux/slices/StaffFormsSlices";
import { authorizedRequests } from "../../../axios/axios-config";
import { toastify } from "../../../helperFunctions/toastify";
import SelectComponent from "../../SharedComponents/SelectComponent";
import { requiredFieldValidation } from "../../../helperFunctions/validation";
import { useLayoutEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertFromRaw, convertToRaw } from "draft-js";
import { getDrawtool } from "../../../apis/drawtool";
import FilerobotImageEditor, {
	TABS,
	TOOLS,
} from "react-filerobot-image-editor";
import { convertFileToBase64 } from "../../../apis/document";
import { uploadSessionFiles, updateSessionPhoto } from "../../../apis/session";
import { getSessionById } from "../../../apis/session";
import { base64ToFile } from "../../../helperFunctions/utils";

import PatientPrescriptionSheet from "./PrescriptionSheet";
import PatientCaseFolder from "../Patient/CaseFolder";
import ModalCamera from "./ModalCamera";

export const SESSION_CURRENT_STATE = Object.freeze({
	patientMedicalHistory: "Patient Medical History",
	patientSOAP: "Patient SOAP",
	patientConsents: "Patient Consents",
	patientChart: "Patient Chart",
	patientPrescriptionSheet: "Patient Prescription Sheet",
	patientCaseFolder: "Patient Case Folder",
});

function PatientMedicalHistory({ setCurrentState }) {
	/////////////////Declarations\\\\\\\\\\\\\\\\

	const { patientMedicalHistory, dataId } = useSelector(
		(state) => state.staffForm.sessionForm,
	);

	const [localState, setLocalStates] = useState(
		patientMedicalHistory.sideEffects || [
			{
				name: "sunExposure",
				isChecked: false,
				value: null,
			},
			{
				name: "smoking",
				isChecked: false,
				value: "",
			},
			{
				name: "alcohol",
				isChecked: false,
				value: "",
			},
		],
	);

	const dispatch = useDispatch();

	/////////////////functions\\\\\\\\\\\\\\\\\\\\
	const onFormChange = (name, value) => {
		dispatch(
			setSubChild({
				parent: "sessionForm",
				child: "patientMedicalHistory",
				subChild: name,
				value,
			}),
		);
	};
	const onLocalChange = (state, name, value) => {
		var tempArr = [...localState];
		var index = localState.findIndex((o) => o.name === state);
		tempArr[index] = { ...tempArr[index], [name]: value };
		if (name === "isChecked") {
			tempArr[index] = { ...tempArr[index], value: "" };
		}
		setLocalStates([...tempArr]);
	};

	const submitForm = async (e) => {
		e.preventDefault();

		const { result, error } = await authorizedRequests({
			url: "session/updateSession",
			method: "post",
			data: {
				dataId,
				patientMedicalHistory: {
					...patientMedicalHistory,
					sideEffects: [...localState],
				},
			},
		});
		if (error) {
			toastify(error?.message, "error");
			return;
		}
		dispatch(
			setForm({
				parent: "sessionForm",
				child: "patientMedicalHistory",
				value: {
					...patientMedicalHistory,
					sideEffects: [...localState],
				},
			}),
		);
		// localStorage.setItem(
		// 	"session_current_state",
		// 	SESSION_CURRENT_STATE.patientSOAP,
		// );
		// setCurrentState(SESSION_CURRENT_STATE.patientSOAP);
		toastify("Success", "success");
		return;
	};

	////////////////////hooks\\\\\\\\\\\\\\\\\\\\

	return (
		<>
			<div className="pb-4 px-4">
				<div className="content">
					<div className="addEdit pb-4">
						<div className="row">
							<div>
								<div className="d-flex w-100">
									<Form.Group className="col-md-5">
										<Form.Label className="black-label-text">
											Patient Medical History
										</Form.Label>
										<InputGroup className="mb-3">
											<Form.Control
												name={"pastMedicalHistory"}
												as="textarea"
												rows={3}
												placeholder="Write..."
												style={{ resize: "none" }}
												onChange={(e) => {
													onFormChange(
														"pastMedicalHistory",
														e.target.value,
													);
												}}
												value={
													patientMedicalHistory.pastMedicalHistory
												}
											/>
										</InputGroup>
									</Form.Group>
									<Form.Group className="col-md-5 ms-3">
										<Form.Label className="black-label-text ">
											Past Cosmetic History
										</Form.Label>
										<InputGroup className="mb-3">
											<Form.Control
												name={"pastCosmeticHistory"}
												as="textarea"
												rows={3}
												placeholder="Write..."
												style={{ resize: "none" }}
												onChange={(e) => {
													onFormChange(
														"pastCosmeticHistory",
														e.target.value,
													);
												}}
												value={
													patientMedicalHistory.pastCosmeticHistory
												}
											/>
										</InputGroup>
									</Form.Group>{" "}
								</div>
								<div className="d-flex w-100">
									<Form.Group className="col-md-5">
										<Form.Label className="black-label-text ">
											Past Adverse Cosmetic History
										</Form.Label>
										<InputGroup className="mb-3">
											<Form.Control
												name={
													"pastAdverseCosmeticHistory"
												}
												as="textarea"
												rows={3}
												placeholder="Write..."
												style={{ resize: "none" }}
												onChange={(e) => {
													onFormChange(
														"pastAdverseCosmeticHistory",
														e.target.value,
													);
												}}
												value={
													patientMedicalHistory.pastAdverseCosmeticHistory
												}
											/>
										</InputGroup>
									</Form.Group>
									<Form.Group className="col-md-5 ms-3">
										<Form.Label className="black-label-text ">
											Social History
										</Form.Label>
										<InputGroup className="mb-3">
											<Form.Control
												name={"socialHistory"}
												as="textarea"
												rows={3}
												placeholder="Write..."
												style={{ resize: "none" }}
												onChange={(e) => {
													onFormChange(
														"socialHistory",
														e.target.value,
													);
												}}
												value={
													patientMedicalHistory.socialHistory
												}
											/>
										</InputGroup>
									</Form.Group>
								</div>
								<div className="col-md-5 mb-3">
									<input
										type={"checkbox"}
										name="sunExposure"
										checked={
											localState.find(
												(o) => o.name === "sunExposure",
											)?.isChecked
										}
										onChange={() => {
											onLocalChange(
												"sunExposure",
												"isChecked",
												!localState.find(
													(o) =>
														o.name ===
														"sunExposure",
												)?.isChecked,
											);
										}}
									/>
									<span
										for="sunExposure"
										className="ms-2 font-400-20"
									>
										Sun Exposure
									</span>
									{localState.find(
										(o) => o.name === "sunExposure",
									)?.isChecked && (
										<Form.Group>
											<InputGroup className="mt-3">
												<Form.Control
													name={"sunExposure"}
													placeholder="Write..."
													onChange={(e) => {
														onLocalChange(
															"sunExposure",
															"value",
															e.target.value,
														);
													}}
													value={
														localState.find(
															(o) =>
																o.name ===
																"sunExposure",
														).value
													}
												/>
											</InputGroup>
										</Form.Group>
									)}
								</div>
								<div className="col-md-5 mb-3">
									<input
										type={"checkbox"}
										name="smoking"
										checked={
											localState.find(
												(o) => o.name === "smoking",
											)?.isChecked
										}
										onChange={() => {
											onLocalChange(
												"smoking",
												"isChecked",
												!localState.find(
													(o) => o.name === "smoking",
												)?.isChecked,
											);
										}}
									/>

									<span className="ms-2 font-400-20">
										Smoking
									</span>
									{localState.find(
										(o) => o.name === "smoking",
									)?.isChecked && (
										<Form.Group>
											<InputGroup className="mt-3">
												<Form.Control
													name={"smoking"}
													placeholder="Write..."
													onChange={(e) => {
														onLocalChange(
															"smoking",
															"value",
															e.target.value,
														);
													}}
													value={
														localState.find(
															(o) =>
																o.name ===
																"smoking",
														).value
													}
												/>
											</InputGroup>
										</Form.Group>
									)}
								</div>
								<div className="col-md-5 mb-3">
									<input
										type={"checkbox"}
										name="alcohol"
										checked={
											localState.find(
												(o) => o.name === "alcohol",
											)?.isChecked
										}
										// value={localState.find((o) => o.name === "alcohol").isChecked}
										onChange={() => {
											onLocalChange(
												"alcohol",
												"isChecked",
												!localState.find(
													(o) => o.name === "alcohol",
												)?.isChecked,
											);
										}}
									/>

									<span className="ms-2 font-400-20">
										Alcohol
									</span>
									{localState.find(
										(o) => o.name === "alcohol",
									)?.isChecked && (
										<Form.Group>
											<InputGroup className="mt-3">
												<Form.Control
													name={"alcohol"}
													placeholder="Write..."
													onChange={(e) => {
														onLocalChange(
															"alcohol",
															"value",
															e.target.value,
														);
													}}
													value={
														localState.find(
															(o) =>
																o.name ===
																"alcohol",
														).value
													}
												/>
											</InputGroup>
										</Form.Group>
									)}
								</div>
							</div>
						</div>
						<div className="mt-3 d-flex align-self-center col-10 ms-3">
							<Button
								style={{ width: "150px" }}
								className="addItem ms-auto"
								onClick={submitForm}
							>
								Save
							</Button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

function PatientSOAP({ setCurrentState }) {
	const { patientSOAP, dataId } = useSelector(
		(state) => state.staffForm.sessionForm,
	);
	// const { sessionForm } = useSelector((state) => state.staffForm);
	const dispatch = useDispatch();

	const [fields, setFields] = useState([
		{
			name: "Subjective",
			value: "subjective",
		},
		{
			name: "Objective",
			value: "objective",
		},
		{
			name: "Assessment",
			value: "assesment",
		},
		{
			name: "Plan",
			value: "plan",
		},
		{
			name: "Recommended Treatment",
			value: "recommendedTreatment",
		},
		{
			name: "Treatment Done",
			value: "treatmentDone",
		},
	]);

	const onFormChange = (name, value) => {
		dispatch(
			setSubChild({
				parent: "sessionForm",
				child: "patientSOAP",
				subChild: name,
				value,
			}),
		);
	};

	const onSubmit = async () => {
		const { result, error } = await authorizedRequests({
			url: "session/updateSession",
			method: "post",
			data: {
				dataId,
				patientSOAP,
			},
		});
		if (error) {
			toastify(error?.message, "error");
			return;
		}

		toastify("Success", "success");
		// localStorage.setItem(
		// 	"session_current_state",
		// 	SESSION_CURRENT_STATE.patientConsents,
		// );
		// setCurrentState(SESSION_CURRENT_STATE.patientConsents);
	};
	return (
		<>
			<div className="px-4 pb-4">
				<div className="addEdit">
					{fields.map((o) => {
						return (
							<>
								<Accordion className="mb-2">
									<Accordion.Item eventKey="0">
										<Accordion.Header className="session-accordion-header">
											{o.name}
										</Accordion.Header>
										<Accordion.Body>
											<Form.Group className="col-md-12 ">
												<InputGroup className="mb-3">
													<Form.Control
														name={o.value}
														as="textarea"
														rows={3}
														placeholder="Write..."
														style={{ resize: "none" }}
														onChange={(e) => {
															onFormChange(
																o.value,
																e.target.value,
															);
														}}
														value={patientSOAP[o.value]}
													/>
												</InputGroup>
											</Form.Group>
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							</>
						);
					})}
					<Button
						className="addItem ms-auto mt-3"
						style={{ width: "150px" }}
						onClick={() => {
							onSubmit();
						}}
					>
						Save
					</Button>
				</div>
			</div>
		</>
	);
}

function PatientConsents({ setCurrentState }) {
	const dispatch = useDispatch();

	const { sessionForm } = useSelector((state) => state.staffForm);
	const [consents, setConsents] = useState([]);
	const [modalShow, setModalShow] = useState(false);
	const [consentToSign, setConsentToSign] = useState();
	const [patientRef, setPatientRef] = useState({});
	const [doctorRef, setDoctorRef] = useState({});

	const [allConsents, setAllConsents] = useState([]);
	const [selectedConsents, setSelectedConsents] = useState([]);

	// const [signatures, setSignatures] = useState(
	// 	sessionForm?.patientConsents?.map((o) => {
	// 		return {
	// 			consent: o.consent,
	// 			pateintSign: o.pateintSign || "",
	// 			doctorSign: o.doctorSign || "",
	// 		};
	// 	}) || [],
	// );

	const getSignatures = async () => {
		//Signatures data to be send in API
		var tempArr = consents?.map((sign) => {
			if (sign._id == consentToSign) {
				return {
					consent: sign.value,
					pateintSign: patientRef.toDataURL("image/png"),
					doctorSign: doctorRef.toDataURL("image/png"),
				};
			} else {
				return {
					consent: sign.value,
					pateintSign: sign.pateintSign,
					doctorSign: sign.doctorSign,
				};
			}
		});

		//signatures to be displayed alongwith their title
		const tempConsentsArr = consents?.map((sign) => {
			if (sign._id == consentToSign) {
				return {
					...sign,
					pateintSign: patientRef.toDataURL("image/png"),
					doctorSign: doctorRef.toDataURL("image/png"),
				};
			} else {
				return {
					...sign,
				};
			}
		});
		setConsents(tempConsentsArr);

		const { result, error } = await authorizedRequests({
			url: "session/updateSession",
			method: "post",
			data: {
				dataId: sessionForm.dataId,
				patientConsents: [...tempArr],
			},
		});
		if (error) {
			toastify(error?.message ?? "Unknown error occured", "error");
			return;
		}
		toastify("Signatures saved succesfully", "success");
		setModalShow(false);
	};

	useMemo(() => {
		if (sessionForm.dataId) {
			(async () => {
				const { result, error } = await getSessionById(
					sessionForm.dataId,
				);
				if (error) {
					toastify("Failed to get session consents", "error");
					return;
				}
				const tempConsentsArr = [];
				const tempSelectedConsents = [];
				result.data.patientConsents?.forEach((o) => {
					tempSelectedConsents.push(o?.consent?._id);
					tempConsentsArr.push({
						...o.consent,
						label: o.consent.title,
						value: o.consent._id,
						pateintSign: o.pateintSign,
						doctorSign: o.doctorSign,
					});
				});
				setConsents(tempConsentsArr);
				setSelectedConsents(tempSelectedConsents);
			})();
		}
	}, [sessionForm.dataId]);

	useEffect(() => {
		(async () => {
			const { result, error } = await authorizedRequests({
				url: "consents/listOfConsents",
				method: "get",
			});
			if (error) {
				toastify(error.message ?? "Can't get consents list", "error");
				return;
			}

			const tempArr = result?.data?.map((o) => {
				return {
					...o,
					label: o.title,
					value: o._id,
					patientSign: "",
					doctorSign: "",
				};
			});
			setAllConsents(tempArr);
		})();
	}, []);

	return (
		<>
			<div className="consent-container px-4 pb-4">
				<div className="addEdit">
					<div className="col-5">
						<SelectComponent
							isNullEnabled
							searchEnabled
							options={allConsents}
							onChange={(value) => {
								setSelectedConsents(value);
								const tempArr = allConsents
									.filter((o) => value.indexOf(o._id) !== -1)
									?.map((o) => {
										const index = consents.findIndex(
											(con) => con._id == o._id,
										);
										if (index !== -1) {
											return {
												...o,
												pateintSign:
													consents[index].pateintSign,
												doctorSign:
													consents[index].doctorSign,
											};
										}
										return o;
									});
								setConsents(tempArr);
							}}
							array={selectedConsents}
						/>
					</div>
				</div>
				{consents.length > 0 &&
					consents.map((con) => {
						return (
							<>
								<Accordion className="mb-2">
									<Accordion.Item eventKey="0">
										<Accordion.Header className="session-accordion-header">
											{con.title}
										</Accordion.Header>
										<Accordion.Body>
											<p className="mt-0 ">
												<Editor
													editorState={EditorState.createWithContent(
														convertFromRaw(
															JSON.parse(con.url),
														),
													)}
													wrapperClassName="p-0"
													editorClassName=" hidePointer"
													disabled
													toolbarHidden={true}
													wrapperStyle={{
														overflow: "hidden",
														padding: "30px 0px",
														marginBottom: "30px",
													}}
												/>
											</p>
											<div className="w-100">
												<Button
													className="addItem ms-auto"
													onClick={() => {
														setModalShow(true);
														setConsentToSign(
															con._id,
														);
													}}
												>
													Sign Here
												</Button>
											</div>
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							</>
						);
					})}
				<Modal
					centered
					show={modalShow}
					onHide={() => {
						setConsentToSign(null);

						setModalShow(!modalShow);
					}}
				>
					<Modal.Header closeButton>
						<Modal.Title>
							<div className="w-100 text-center">
								Add Signatures
							</div>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div>
							<div
								className="patient-signature"
								style={{
									background: "#F8F8F8",
									borderRadius: " 12px",
								}}
							>
								<div
									className="text-center p-3 grey font-400-20"
									style={{
										borderBottom: "2px solid #E9E9E9",
									}}
								>
									Patient's Signature
								</div>
								<SignatureCanvas
									penColor="green"
									ref={(ref) => {
										console.log(consents);
										ref?.fromDataURL(
											consents.find(
												(o) => o._id === consentToSign,
											)?.pateintSign,
										);

										setPatientRef(ref);
									}}
									canvasProps={{
										width: 500,
										height: 200,
										className: "sigCanvas",
									}}
								/>
							</div>
							<Button
								className="grey-rounded-button ms-auto mt-3"
								onClick={() => {
									patientRef.clear();
								}}
							>
								Clear Box
							</Button>
							<div
								className="doctor-signature"
								style={{
									background: "#F8F8F8",
									borderRadius: " 12px",
								}}
							>
								<div
									className="text-center mt-3 p-3 grey font-400-20"
									style={{
										borderBottom: "2px solid #E9E9E9",
									}}
								>
									Doctor's Signature
								</div>
								<SignatureCanvas
									penColor="green"
									ref={(ref) => {
										ref?.fromDataURL(
											consents.find(
												(o) => o._id === consentToSign,
											)?.doctorSign,
										);

										setDoctorRef(ref);
									}}
									canvasProps={{
										width: 500,
										height: 200,
										className: "sigCanvas",
									}}
								/>
							</div>
							<Button
								className="grey-rounded-button ms-auto mt-3"
								onClick={() => {
									doctorRef.clear();
								}}
							>
								Clear Box
							</Button>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button
							className="addItem"
							// variant="addItem"
							onClick={getSignatures}
						>
							Save
						</Button>
					</Modal.Footer>
				</Modal>
			</div>
		</>
	);
}

function PatientChart({ setCurrentState, disabled }) {
	const { sessionForm } = useSelector((state) => state.staffForm);

	const [markers, setMarkers] = useState([]);
	const [faces, setFaces] = useState([]);
	const [selectedFace, setSelectedFace] = useState();
	const navigate = useNavigate();
	// const [activeDrags, setActiveDrags] = useState(0);
	// const [drags, setDrags] = useState([]);
	const [captions, setCaptions] = useState([]);
	const [text, setText] = useState("");
	const [tab, setTab] = useState("");
	const [preview, setPreview] = useState();
	const [editedImage, setEditedImage] = useState();
	// const editorProps = {
	// 	includeUI: {
	// 		menu: ["text", "draw", "crop", "flip", "rotate"],
	// 		initMenu: "draw",
	// 		uiSize: {
	// 			width: "1000px",
	// 			height: "700px",
	// 		},
	// 		menuBarPosition: "bottom",
	// 		loadImage: {
	// 			name: "Face",
	// 			path: selectedFace
	// 				? selectedFace.imageUrl
	// 				: "https://bluesilo-epion.s3.ap-southeast-1.amazonaws.com/Face%203.png",
	// 		},
	// 	},
	// 	// cssMaxHeight={500}
	// 	cssMaxWidth: 400,
	// 	selectionStyle: {
	// 		cornerSize: 20,
	// 		rotatingPointOffset: 70,
	// 	},
	// 	usageStatistics: true,
	// };

	// const CustomMarker = (props) => {
	// 	return <div className="drawtool-marker"></div>;
	// };

	// const undo = () => {
	// 	let _markers = [...markers];
	// 	_markers.pop();
	// 	setMarkers(_markers);
	// };

	// const createTextbox = () => {
	// 	if (text && text !== "") {
	// 		let _text = [...captions];
	// 		_text.push(text);
	// 		setText("");
	// 		setCaptions(_text);
	// 		setTab("");
	// 	}
	// };

	const changeFace = async (e) => {
		const getImage = await convertFileToBase64({ url: e.imageUrl });
		setSelectedFace(getImage.data);
		setMarkers([]);
		setCaptions([]);

		setPreview(getImage.data);
	};

	const submitForm = async (img) => {
		if (!img?.imageBase64) {
			toastify("Image is missing", "error");
			return;
		}
		const Editedfile = base64ToFile(img?.imageBase64, img?.fullName);
		// console.log(sessionForm);
		// return;
		const formData = new FormData();
		formData.append("dataId", sessionForm.dataId);
		formData.append("patientId", sessionForm.dataId);

		formData.append("file", Editedfile);
		formData.append("name", img?.fullName);
		formData.append("type", "img");
		formData.append("isDefault", true);

		const { result, error } = await uploadSessionFiles(formData);
		if (error) {
			toastify(error.message ?? "Failed to upload image", "error");
			return;
		}
		toastify("Image Uploaded succesfully", "success");
		// navigate("/session");
		return;
	};
	const populateTemplates = async () => {
		const response = await getDrawtool();
		if (response?.status !== "Fail") {
			setFaces(response || []);
		} else {
			if (response?.message === "No data Found") {
				setFaces([]);
			} else {
				toastify(response?.message, "error");
			}
		}
	};
	const populatePatientChart = async () => {
		const { link } = sessionForm.patientChart.find((o) => o.isDefault);
		if (link) {
			const getImage = await convertFileToBase64({ url: link });
			setSelectedFace(getImage.data);
			setMarkers([]);
			setCaptions([]);

			setPreview(getImage.data);
		}
	};

	useEffect(() => {
		populateTemplates();
	}, []);
	useMemo(() => {
		if (sessionForm?.patientChart?.length > 0) {
			populatePatientChart();
		}
	}, [sessionForm?.patientChart]);
	return (
		<div className="px-4 mb-5 pb-4 h-100">
			<div className="mainHeading px-4">
				<h1>Drawtool Template</h1>
			</div>

			<div className="image-container-1 pb-4">
				{faces &&
					faces?.length > 0 &&
					faces?.map((e, i) => (
						<div
							key={i}
							className="d-flex p-2 mx-3 h-100"
							style={{ border: "1px solid gray" }}
						>
							<img
								src={e.imageUrl}
								alt="img"
								className="drawtool-images"
								onClick={() => {
									changeFace(e);
								}}
							/>
						</div>
					))}
			</div>

			<div className="drag-container">
				<div
					className={`${
						tab === "zoomin" || tab === "pen"
							? "zoom-kro"
							: "na-kro "
					}`}
				>
					{selectedFace && (
						<div
							className={`w-100 ${!disabled ? "" : "hide-btn"}`}
							style={{
								width: window.innerWidth > 1280 ? 1500 : 1000,
							}}
						>
							{
								disabled ? (
									<FilerobotImageEditor
										// source="https://scaleflex.airstore.io/demo/stephen-walker-unsplash.jpg"
										source={`data:application/image;base64,${preview}`}
										onBeforeSave={() => {}}
										onSave={() => {}}
										annotationsCommon={{
											fill: "#000000",
											stroke: "#000000",
											strokeWidth: 1,
										}}
										Text={{ text: "Write..." }}
										// disableZooming
										Rotate={{ angle: 90, componentType: "slider" }}
										tabsIds={["Annotate"]}
										toolbar={{
											showSaveBtn: false
										}}
										defaultSavedImageName={new Date().getTime()}
									/>
								) : (
									<FilerobotImageEditor
										// source="https://scaleflex.airstore.io/demo/stephen-walker-unsplash.jpg"
										source={`data:application/image;base64,${preview}`}
										onBeforeSave={function (imageFileInfo) {
											return false;
										}}
										onSave={(editedImageObject, designState) => {
											// setEditedImage(editedImageObject);
											submitForm(editedImageObject);
										}}
										annotationsCommon={{
											fill: "#000000",
											stroke: "#000000",
											strokeWidth: 1,
										}}
										Text={{ text: "Write..." }}
										// disableZooming
										Rotate={{ angle: 90, componentType: "slider" }}
										tabsIds={["Annotate"]}
										defaultTabId={TABS.ANNOTATE}
										defaultToolId={TOOLS.TEXT}
										defaultSavedImageName={new Date().getTime()}
									/>
								)
							}
						</div>
					)}
				</div>
				{/* <div className="w-100 mt-4">
					<Button
						className="addItem ms-auto"
						style={{ width: "150px" }}
						onClick={() => {
							submitForm();
						}}
					>
						Save
					</Button>
				</div> */}
			</div>
		</div>
	);
}

export default function PatientDetails() {
	const [currentState, setCurrentState] = useState();
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const { sessionForm } = useSelector((state) => state.staffForm);
	const userData = useSelector((state) => state.userData.value);
	const isDoctor = userData.department?.name?.toLowerCase()?.includes("doctor");
	const [photo, setPhoto] = useState(location?.state?.valueObj?.photoSession ?? "");
	const [openCamera, setOpenCamera] = useState(false);

	const adjustCurrentState = (state) => {
		setCurrentState(state);
		localStorage.setItem("session_current_state", state);
	};
	// useEffect(() => {
	// 	if (!sessionForm.dataId) {
	// 		navigate(-1);
	// 	}
	// }, []);
	useEffect(() => {
		if (location?.state?.valueObj) {
			dispatch(
				setData({
					parent: "sessionForm",
					value: location?.state?.valueObj,
				}),
			);
		} else {
			if (!sessionForm.dataId) {
				navigate(-1);
			}
		}
	}, [location?.state?.valueObj, sessionForm.dataId]);

	useEffect(() => {
		const curState = localStorage.getItem("session_current_state");
		if (!curState) {
			localStorage.setItem(
				"session_current_state",
				SESSION_CURRENT_STATE.patientMedicalHistory,
			);
		} else {
			setCurrentState(curState);
		}
	}, [localStorage.getItem("session_current_state")]);

	const handleTakePhoto = (dataUri) => {
		setPhoto(dataUri);
	}
	
	const handleSavePhoto = async() => {
		const sessionForm = location?.state?.valueObj;
		const photoName = `Photo Session`;
		const Editedfile = base64ToFile(photo, photoName);

		const formData = new FormData();
		formData.append("dataId", sessionForm.dataId);
		formData.append("patientId", sessionForm.dataId);

		formData.append("file", Editedfile);
		formData.append("name", photoName);
		formData.append("type", "img");

		const { result, error } = await updateSessionPhoto(formData);
		if (error) {
			toastify(error.message ?? "Failed to upload image", "error");
			setOpenCamera(false);
		} else {
			toastify("Image Uploaded succesfully", "success");
			setOpenCamera(false);
		}
	}

	return (
		<>
			<div className="mainHeading px-4">
				<h1>
					<span
						className="grey font-400-20"
						onClick={() => {
							navigate("/session");
						}}
					>
						Session/
					</span>
					{currentState}
				</h1>
				<div>
					<LinkedCameraIcon onClick={() => setOpenCamera(true)} style={{fontSize: 30, color: "#365c78", cursor: "pointer"}} />
					<ModalCamera 
						openModal={openCamera}
						setOpenModal={setOpenCamera}
						handleTakePhoto={handleTakePhoto}
						handleSave={handleSavePhoto}
						photo={photo}
						existingPhoto={location?.state?.valueObj?.photoSession ?? ""}
					/>
				</div>
			</div>
			<div className="w-100 d-flex justify-content-center">
				{
					isDoctor && (
						<React.Fragment>
							<Button
								className={`${
									currentState ===
									SESSION_CURRENT_STATE.patientMedicalHistory
										? "theme-rounded-button"
										: "white-rounded-button"
								} ms-3 mb-3`}
								onClick={() => {
									adjustCurrentState(
										SESSION_CURRENT_STATE.patientMedicalHistory,
									);
								}}
							>
								Patient Medical History
							</Button>
							<Button
								className={`${
									currentState === SESSION_CURRENT_STATE.patientSOAP
										? "theme-rounded-button"
										: "white-rounded-button"
								} ms-3 mb-3`}
								onClick={() => {
									adjustCurrentState(SESSION_CURRENT_STATE.patientSOAP);
								}}
							>
								Patient SOAP
							</Button>
						</React.Fragment>
					)
				}
				<Button
					className={`${
						currentState === SESSION_CURRENT_STATE.patientConsents
							? "theme-rounded-button"
							: "white-rounded-button"
					} ms-3 mb-3`}
					onClick={() => {
						adjustCurrentState(
							SESSION_CURRENT_STATE.patientConsents,
						);
					}}
				>
					Patient Consents
				</Button>
				<Button
					className={`${
						currentState === SESSION_CURRENT_STATE.patientChart
							? "theme-rounded-button"
							: "white-rounded-button"
					} ms-3 mb-3`}
					onClick={() => {
						adjustCurrentState(SESSION_CURRENT_STATE.patientChart);
					}}
				>
					Patient Chart
				</Button>
				{
					isDoctor && (
						<React.Fragment>
							<Button
								className={`${
									currentState === SESSION_CURRENT_STATE.patientPrescriptionSheet
										? "theme-rounded-button"
										: "white-rounded-button"
								} ms-3 mb-3`}
								onClick={() => {
									adjustCurrentState(SESSION_CURRENT_STATE.patientPrescriptionSheet);
								}}
							>
								Patient Prescription Sheet
							</Button>
						</React.Fragment>
					)
				}
				<Button
					className={`${
						currentState === SESSION_CURRENT_STATE.patientCaseFolder
							? "theme-rounded-button"
							: "white-rounded-button"
					} ms-3 mb-3`}
					onClick={() => {
						adjustCurrentState(SESSION_CURRENT_STATE.patientCaseFolder);
					}}
				>
					Case Folder
				</Button>
			</div>
			<div className="patient-details-body">
				{currentState === SESSION_CURRENT_STATE.patientMedicalHistory && (
					<>
						<PatientMedicalHistory
							setCurrentState={setCurrentState}
						/>
					</>
				)}
				{currentState === SESSION_CURRENT_STATE.patientSOAP && (
					<>
						<PatientSOAP setCurrentState={setCurrentState} />
					</>
				)}
				{currentState === SESSION_CURRENT_STATE.patientConsents && (
					<>
						<PatientConsents setCurrentState={setCurrentState} />
					</>
				)}
				{currentState === SESSION_CURRENT_STATE.patientChart && (
					<>
						<PatientChart setCurrentState={setCurrentState} disabled={!isDoctor} />
					</>
				)}
				{currentState === SESSION_CURRENT_STATE.patientPrescriptionSheet && (
					<>
						<PatientPrescriptionSheet setCurrentState={setCurrentState} />
					</>
				)}
				{currentState === SESSION_CURRENT_STATE.patientCaseFolder && (
					<div style={{paddingLeft: "25px", paddingRight: "25px"}}>
						<PatientCaseFolder setCurrentState={setCurrentState} />
					</div>
				)}
			</div>
		</>
	);
}
